import { useState } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import WheatherCard from './components/WheatherCard';
function App() {
  const apiKey = process.env.REACT_APP_WHEATHER_API
  const [mode,setMode] = useState('light');
  const changeMode=()=>{
    if(mode==='light'){
      setMode('dark');
      document.body.style.backgroundColor = '#101414';
    }
    else{
      setMode('light');
      document.body.style.backgroundColor = 'white';
    }
  }
  return (
    <div>
      <Navbar mode={mode} changeMode={changeMode}/>
      <WheatherCard mode={mode} apiKey={apiKey}/>
      <div className='my-3 mx-3' style={{textAlign:'center'}}>Designed and developed by <a href='https://www.siddhartha.ml/' target="_blank">Narala Siddhartha</a>.</div>
    </div>
  );
}

export default App;
